export const NEWSLETTER_TYPES = {
    all: '8cb9eac6-bc0a-43cb-8126-218b8ed478b2',
    conference: '7851e6f6-5ab3-473c-82c4-6c29690b179f',
    everyweek: '29f49bbc-f4be-4f09-936b-b0fda734aa6a',
    everyday: '8dd7e22a-039d-4a96-b788-ee01e2874a61',
};
